import React, { FocusEventHandler } from 'react'

import { useTranslation } from 'react-i18next'
import MaskedInput from 'react-text-mask'

export type MaskedDateInputProps = {
  inputRef: (ref: HTMLElement | null) => void
  onFocus?: FocusEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
}

export const MaskedDateInput = (props: MaskedDateInputProps) => {
  const { t } = useTranslation()
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(ref: MaskedInput | null) => {
        inputRef?.(ref ? ref.inputElement : null)
      }}
      mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      placeholder={t('date_placeholder')}
      showMask={false}
    />
  )
}
